module.exports = __webpack_public_path__ + "img/splitpng2.37884260.png";